// main.js
var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
jQueryBridget( 'flickity', Flickity, $ );
// now you can use $().flickity()
$('.flickity').flickity({
  autoPlay: true,
  pageDots: false,
  prevNextButtons: false,
  pauseAutoPlayOnHover: false
});


$(document).ready(function(){
  $('.tab-link').on('touchstart click', function(e){
    e.preventDefault();
    $('.tab-link.active, .menu-contents.active').removeClass('active');
    $(this).addClass('active');
    var target = $(this).attr('href');
    $('.tab-select').val(target);
    $(target).addClass('active');
  });

  $('.tab-select').on('change', function(){
    $('.tab-link.active, .menu-contents.active').removeClass('active');
    var target = $(this).val();
    $('.tab-link[href="'+target+'"]').addClass('active');
    $(target).addClass('active');
  });
})
